import React, { useEffect, useState } from "react";
import { ScrollArea, useToast, Spinner } from "../../components/ui";
import constant, { statuses } from "../../constants";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { Header, UserPreview } from "../../components/modules";
import Context from "../../Context";
import { RiCoupon2Line } from "react-icons/ri";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";

export const BundleOrderInfo = () => {
  const { toast } = useToast();
  const { orderId } = useParams();
  const { callApi, navigate } = Context();
  const [order, setOrder] = useState(false);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");

  useEffect(() => {
    getOrder();
    // eslint-disable-next-line
  }, []);

  const getOrder = async () => {
    setLoading(true);
    const { status, data } = await callApi(
      "coupons-getBundleOrders",
      { id: orderId },
      { notShowLoading: true },
    );

    if (status) {
      setOrder(data);
      if (data?.userId) {
        getUser(data.userId);
      }
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> ไม่พบคำสั่งซื้อ
          </div>
        ),
      });
      navigate("/coupon/orders/bundle");
    }
    setLoading(false);
  };

  const getUser = async (userId) => {
    const { status, data } = await callApi(
      "users-getUserInfoAdmin",
      { userId },
      { notShowLoading: true },
    );
    if (status) setUser(data);
  };

  const handleApprove = async () => {
    if (!window.confirm("ต้องการอนุมัติคำสั่งซื้อนี้ใช่หรือไม่?")) return;
    setLoading(true);
    const { status } = await callApi(
      "coupons-editBundleOrder",
      { id: order.id, key: "status", value: "approved" },
      { notShowLoading: true },
    );
    if (status) {
      toast({
        className: "bg-green",
        title: (
          <div className="flex gap-2 items-center">
            <FaCheckCircle /> อนุมัติสำเร็จ
          </div>
        ),
      });
      getOrder();
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> อนุมัติไม่สำเร็จ
          </div>
        ),
      });
    }
    setLoading(false);
  };

  const handleAddNote = async () => {
    if (!note.trim()) return;
    if (!window.confirm("ต้องการเพิ่มโน๊ตใช่หรือไม่")) return;
    setLoading(true);
    const { status } = await callApi(
      "coupons-editBundleOrder",
      { id: order.id, key: "note", value: note },
      { notShowLoading: true },
    );
    if (status) {
      toast({
        className: "bg-green",
        title: (
          <div className="flex gap-2 items-center">
            <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
          </div>
        ),
      });
      setNote("");
      getOrder();
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> อัพเดตข้อมูลไม่สำเร็จ
          </div>
        ),
      });
    }
    setLoading(false);
  };

  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto">
      <Header
        header="Coupons"
        subHeader={`คำสั่งซื้อแพ็กเกจ ${order ? order.shortId : orderId.slice(-5).toUpperCase()}`}
        icon={<RiCoupon2Line className="text-blue" />}
      />

      <div className="grid grid-cols-3 gap-3 mt-4">
        {/* Order Info */}
        <div className="relative col-span-2 bg-white w-full rounded-md shadow-md border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white items-center gap-3 p-3 border-b border-[#E5E7E9] justify-between">
            <p className="font-semibold text-xl">
              ข้อมูลคำสั่งซื้อแพ็กเกจ {order && order.shortId}
            </p>
          </div>

          {!order ? (
            <div className="flex justify-center items-center h-64 w-full">
              <Spinner className="w-4 h-4" />
            </div>
          ) : (
            <div className="relative p-3 grid grid-cols-4 gap-3 *:min-w-0">
              {loading && (
                <div className="absolute inset-0 z-50 bg-[rgb(255,255,255,0.7)] flex items-center justify-center rounded-md">
                  <Spinner className="w-5 h-5" />
                </div>
              )}

              {/* Status */}
              <div className="">
                <p className="font-semibold">สถานะคำสั่งซื้อ</p>
                <div className="flex">
                  {loading ? (
                    <div className="flex items-center gap-2 py-1.5 px-3 bg-slate-100 rounded-md border border-slate-200 text-xs font-bold text-slate-700 w-full">
                      <Spinner className="w-3.5 h-3.5" />
                      <span>กำลังเปลี่ยนสถานะ...</span>
                    </div>
                  ) : (
                  <select
                    disabled={loading}
                    className={`${
                      order.status === statuses.APPROVE
                        ? "bg-green text-white"
                        : order.status === statuses.PAID
                          ? "bg-[#4DA1A9] text-white"
                          : "bg-[#c15b78] text-white"
                    } border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm disabled:text-gray-500 disabled:border-gray-200 disabled:cursor-not-allowed`}
                    value={order?.status || ""}
                    onChange={async (e) => {
                      if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
                        setLoading(true);
                        const result = await callApi(
                          "coupons-editBundleOrder",
                          {
                            id: order?.id,
                            key: "status",
                            value: e.target.value,
                          },
                          { notShowLoading: true },
                        );
                        if (result.status) {
                          toast({
                            className: "bg-green",
                            title: (
                              <div className="flex gap-2 items-center">
                                <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
                              </div>
                            ),
                          });
                          getOrder();
                        } else {
                          toast({
                            className: "bg-[#c15b78]",
                            title: (
                              <div className="flex gap-2 items-center">
                                <FaTimes /> อัพเดตข้อมูลไม่สำเร็จ
                              </div>
                            ),
                          });
                        }
                        setLoading(false);
                      }
                    }}
                  >
                    <option value={statuses.APPROVE}>
                      {constant.statusesTranslate.approved}
                    </option>
                    <option disabled={true} value={statuses.PAID}>
                      {constant.statusesTranslate.paid}
                    </option>
                    <option value={statuses.CANCEL}>
                      {constant.statusesTranslate.canceled}
                    </option>
                  </select>
                  )}
                </div>
              </div>

              {/* Created At */}
              <div className="w-fit">
                <p className="font-semibold">วัน-เวลา สร้างออเดอร์</p>
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                  disabled
                  value={
                    new Date(order.createdAt).toLocaleDateString("th-TH", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                    }) + " น."
                  }
                />
              </div>

              {/* ShortId */}
              <div className="w-fit">
                <p className="font-semibold">รหัสคำสั่งซื้อ</p>
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                  disabled
                  value={order.shortId || ""}
                />
              </div>

              {/* Slip */}
              <div className="row-span-5">
                <p className="font-semibold">สลิปการชำระเงิน</p>
                {order.slip ? (
                  <a href={order.slip} target="_blank" rel="noreferrer">
                    <img
                      src={order.slip}
                      alt="slip"
                      className="w-full max-w-xs rounded-md mt-1"
                    />
                  </a>
                ) : (
                  <p className="text-gray-400 font-semibold mt-1">ไม่พบสลิป</p>
                )}
              </div>

              {/* Bundle Name */}
              <div className="w-fit">
                <p className="font-semibold">ชื่อแพ็กเกจ</p>
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                  disabled
                  value={order.bundle?.name || ""}
                />
              </div>

              {/* Price */}
              <div className="w-fit">
                <p className="font-semibold">ราคา (บาท)</p>
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                  disabled
                  value={Number(order.price).toLocaleString()}
                />
              </div>

              {/* RoundDate */}
              <div className="w-fit">
                <p className="font-semibold">งวด</p>
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                  disabled
                  value={order.roundDate || "-"}
                />
              </div>

              {/* Approved By */}
              {order.approvedBy && (
                <div className="w-fit">
                  <p className="font-semibold">อนุมัติโดย</p>
                  <input
                    className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                    disabled
                    value={order.approvedBy}
                  />
                </div>
              )}

              {/* Approved At */}
              {order.approvedAt && (
                <div className="w-fit">
                  <p className="font-semibold">วัน-เวลาอนุมัติ</p>
                  <input
                    className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md disabled:border-gray-200 disabled:cursor-not-allowed"
                    disabled
                    value={
                      new Date(order.approvedAt).toLocaleDateString("th-TH", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                      }) + " น."
                    }
                  />
                </div>
              )}

              {/* Bundle Image */}
              {order.bundle?.image && (
                <div className="col-span-2">
                  <p className="font-semibold">รูปภาพแพ็กเกจ</p>
                  <img
                    src={order.bundle.image}
                    alt={order.bundle.name}
                    className="w-40 rounded-md mt-1"
                  />
                </div>
              )}

              {/* Created Coupon Orders (after approval) */}
              {(order.couponOrders || []).length > 0 && (
                <div className="col-span-3">
                  <p className="font-semibold mb-2">คูปองออเดอร์ที่สร้าง</p>
                  <div className="border border-[#E5E7E9] rounded-md overflow-hidden">
                    <Table>
                      <TableHeader className="bg-[#f2f3f5]">
                        <TableRow>
                          <TableHead>ลำดับ</TableHead>
                          <TableHead>รหัสคำสั่งซื้อ</TableHead>
                          <TableHead>ชื่อคูปอง</TableHead>
                          <TableHead className="text-center">
                            สถานะคูปอง
                          </TableHead>
                          <TableHead />
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {order.couponOrders.map((co, i) => (
                          <TableRow key={co.id}>
                            <TableCell className="font-semibold">
                              {i + 1}
                            </TableCell>
                            <TableCell className="font-bold font-mono">
                              {co.shortId}
                            </TableCell>
                            <TableCell className="font-semibold">
                              {co.couponName}
                            </TableCell>
                            <TableCell className="text-center">
                              <div
                                className={`${
                                  co.couponStatus === "active"
                                    ? "bg-[rgb(59,176,101)]"
                                    : co.couponStatus === "used"
                                      ? "bg-[#FAB12F]"
                                      : "bg-[#c15b78]"
                                } w-fit px-3 py-1 text-white text-sm font-semibold rounded-md mx-auto`}
                              >
                                {constant.statusesTranslate[co.couponStatus] ||
                                  co.couponStatus}
                              </div>
                            </TableCell>
                            <TableCell>
                              <button
                                className="py-1.5 px-3 bg-blue text-white font-semibold rounded-md text-sm hover:opacity-60 duration-150"
                                onClick={() =>
                                  window.open(`/coupon/${co.id}`, "_blank")
                                }
                              >
                                ดูรายละเอียด
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Notes Panel */}
        <div className="relative row-span-2 h-fit bg-white w-full rounded-md shadow-md border border-[#E5E7E9] overflow-hidden">
          {loading && (
            <div className="absolute w-full z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
              <Spinner className="w-4 h-4" />
            </div>
          )}
          <div className="flex bg-white items-center gap-3 p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold text-xl">โน๊ต</p>
          </div>
          <div className="p-3">
            <div className="flex gap-2">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-md placeholder:text-sm"
                type="text"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddNote()}
                placeholder="โน๊ต"
              />
              <button
                disabled={loading || !note.trim()}
                className="bg-green rounded-md w-fit p-2 font-semibold flex justify-center items-center gap-2 text-white hover:opacity-85 disabled:opacity-55"
                onClick={handleAddNote}
              >
                เพิ่ม
              </button>
            </div>
            <ScrollArea className="h-[450px] mt-3">
              {order && (order.note || []).length > 0 ? (
                [...(order.note || [])]
                  .sort((a, b) => b.time - a.time)
                  .map((n) => (
                    <div
                      key={n.time}
                      className="bg-blue py-2 px-3 rounded-md text-white mb-2"
                    >
                      <p className="text-lg font-semibold">{n.by}</p>
                      <p className="text-xs font-semibold">
                        {new Date(n.time).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        })}
                      </p>
                      <p className="break-all font-semibold mt-3">{n.note}</p>
                    </div>
                  ))
              ) : (
                <div className="h-full w-full flex justify-center items-center text-gray-400 font-semibold">
                  <p>ไม่พบข้อมูล</p>
                </div>
              )}
            </ScrollArea>
          </div>
        </div>

        {/* User Info */}
        {user && (
          <div className="col-span-2">
            <UserPreview user={user} />
          </div>
        )}
      </div>
    </div>
  );
};
